export default __webpack_public_path__ + "static/media/recycle.63e502b8.png";